/**
 * Color picker that opens a SketchPicker overlay.
 */
import { Box, Button } from "@mui/material";
import React, { useState } from "react";
import { SketchPicker } from "react-color";
import PropTypes from "prop-types";

import { VText } from ".";

/**
 * Button-triggered hex color picker.
 *
 * @param {{ color: string, setColor: Function, children: React.ReactNode }} props
 */
const VColorPicker = (props) => {
  const { color, setColor, children, ...rest } = props;

  const [show, setShow] = useState(false);

  /**
   * Writes the selected hex color through `setColor`.
   *
   * @param {{ hex: string }} val Color picker value.
   * @returns {void}
   */
  const onChange = (val) => {
    setColor(val.hex);
  };

  return (
    <Box className="w-min">
      <Button variant="contained" onClick={() => setShow(true)} style={{ backgroundColor: color }} {...rest}>
        {children}
      </Button>

      <VText color="secondary" div className="text-center mt-2 text-xs">
        {color}
      </VText>

      {show && (
        <Box className="absolute z-10">
          <Box className="fixed top-0 right-0 left-0 bottom-0" onClick={() => setShow(false)} />
          <SketchPicker color={color} onChange={onChange} disableAlpha={true} />
        </Box>
      )}
    </Box>
  );
};

VColorPicker.defaultProps = {
  color: "#DBCD19",
  setColor: () => {},
};

VColorPicker.propTypes = {
  color: PropTypes.string.isRequired,
  children: PropTypes.any.isRequired,
  setColor: PropTypes.func.isRequired,
};

export default VColorPicker;
